function getDifferenceInMinutes(startDate, endDate) {
  return Math.round((((startDate - endDate) % 86400000) % 3600000) / 60000);
}

function isToday(dateObject) {
  const dateToCompare = new Date(
    dateObject.getFullYear(),
    dateObject.getMonth(),
    dateObject.getDate(),
  );

  const now = new Date();
  const today = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate(),
  );

  return today.valueOf() === dateToCompare.valueOf();
}

function subtractMinutes(date, minutes) {
  return new Date(date - minutes * 60000);
}

function addDays(date, days) {
  return new Date(new Date().setDate(new Date(date).getDate() + days));
}

function addMinutes(date, minutes) {
  return new Date(date + minutes * 60000);
}

/**
 * Convert time into minutes and military time and support various time
 * layout (e.g. "8:00 AM", "12:30 PM", "08:30 am", "8:30AM") .
 * Returns null if val is null/falsy.
 */
function toMilitaryTimeVal(val) {
  if (!val || val === 'null' || typeof val !== 'string') {
    return null;
  }
  const match = /^(\d{1,2})(?::(\d{2}))?\s*([AaPp][Mm])$/.exec(val.trim());
  try {
    if (!match) {
      return null;
    }
    let hour = Number(match[1]);
    const minute = Number(match[2] ?? '0');
    const period = match[3].toUpperCase();
    if (Number.isNaN(hour) || Number.isNaN(minute) || minute < 0 || minute > 59) {
      return null;
    }
    if (hour === 12) {
      hour = 0;
    }
    if (period === 'PM') {
      hour += 12;
    }
    return (hour * 60) + minute;
  } catch {
    return null;
  }
}

export {
  getDifferenceInMinutes,
  isToday,
  subtractMinutes,
  addDays,
  addMinutes,
  toMilitaryTimeVal,
};
